import React from 'react';

import skullSwords from "../../assets/img/stores/skull_swords.svg";

// The map artwork is 1920x970 and is painted across the full width of the header,
// offset from its top by 6.5% of the header height (1920x1272). Everything below is
// expressed in that artwork's own pixel space and converted here, so a country's
// point, its label and the dashed line between them can never drift apart.
const MAP_W = 1920;
const HEADER_H = 1272;
const MAP_TOP = 0.065 * HEADER_H;

const toHeader = ({ x, y }) => ({ x, y: y + MAP_TOP });

const pct = ({ x, y }) => ({
    left: `${(x / MAP_W) * 100}%`,
    top: `${(y / HEADER_H) * 100}%`,
});

// A gentle arc between the country and its label. The control point is pushed
// perpendicular to the line so every connector curves the same way the original
// hand-drawn routes did.
const arc = (from, to) => {
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const mx = (from.x + to.x) / 2;
    const my = (from.y + to.y) / 2;
    const len = Math.sqrt(dx * dx + dy * dy) || 1;
    const bend = len * 0.18;
    const cx = mx - (dy / len) * bend;
    const cy = my + (dx / len) * bend;
    return `M${from.x},${from.y} Q${cx},${cy} ${to.x},${to.y}`;
};

// Stop the line short of both ends so it meets the dot and the skull cleanly
// instead of running underneath them.
const trim = (from, to, startGap, endGap) => {
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const len = Math.sqrt(dx * dx + dy * dy) || 1;
    return [
        { x: from.x + (dx / len) * startGap, y: from.y + (dy / len) * startGap },
        { x: to.x - (dx / len) * endGap, y: to.y - (dy / len) * endGap },
    ];
};

const StoresMap = ({ cities, onSelect }) => (
    <>
        <svg
            className="map-connectors"
            viewBox={`0 0 ${MAP_W} ${HEADER_H}`}
            aria-hidden="true"
        >
            {cities?.map((city) => {
                if (!city.point || !city.label) return null;
                const point = toHeader(city.point);
                const label = toHeader(city.label);
                const [start, end] = trim(point, label, 9, 58);
                return (
                    <g key={city.scrollId}>
                        <circle cx={point.x} cy={point.y} r="5.5" />
                        <path d={arc(start, end)} />
                    </g>
                );
            })}
        </svg>
        {cities?.map((city) => (
            <div className="path" id={city.id} key={city.scrollId} style={pct(toHeader(city.label))}>
                <button className="map-button" onClick={() => onSelect(city?.cityId)}>
                    <img src={skullSwords} alt="" className="map-skull" />
                    <span className="map-country-name script-lettering">{city.name}</span>
                </button>
            </div>
        ))}
    </>
);

export default StoresMap;
